<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input placeholder="Procurar"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="buttons">
                    <router-link :to="'/interface/maintenance/' + equipmentId" class="button is-primary">
                        Incluir
                    </router-link>
                </div>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input placeholder="Código"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 aria-next-label="Próxima página"
                 aria-previous-label="Página anterior"
                 aria-page-label="Página"
                 aria-current-label="Página atual">

            <template slot-scope="props" @click="abrirCadastro(props.row.id)">
                <b-table-column field="id" label="Código">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="NomeTecnico" label="Nome Tecnico">
                    {{ props.row.nomeTecnico }}
                </b-table-column>

                <b-table-column field="DataAgendada" label="DataAgendada">
                    {{ $moment(props.row.dataAgendada).format("DD/MM/YYYY HH:mm") }}
                </b-table-column>

                <b-table-column field="Funcionario" label="Funcionario">
                    {{ props.row.funcionarioNome}}
                </b-table-column>

                <b-table-column custom-key="actions" numeric>
                    <router-link :to="{ name: 'interfacemaintenance', params: { equipmentId: equipmentId, id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>

            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
                equipmentId: this.$route.params.equipmentid ?? 0
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    'Interface',
                    'Manutenções',
                    this.equipmentId
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `equipmentId=${this.equipmentId}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/interface/ManutencoesEquipamento?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/interface/maintenance/${this.equipmentId}/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>